"use client";

import React, { useState, useEffect, useRef } from "react";
import UralityImage from "@/components/shared/UralityImage";
import useApi from "@/components/api/useApi";
import { useMediaQuery } from "react-responsive";
import "@/components/shared/ProfileCoverPhoto.css";

const axios = require("axios");

const ProfileCoverPhoto = ({
  className,
  coverPhotoId,
  coverPhotoAsset,
  id,
  temporaryImage,
  edit,
  children,
  aspectRatio = "16x9",
  coverRatio = null, // New coverRatio prop,
  maxHeight = null
}) => {
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });
  const [coverPhotoUrl, setCoverPhotoUrl] = useState(null);
  const api = useApi();
  const coverPhotoRef = useRef();

  const isUrl = url => {
    var expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
    var regex = new RegExp(expression);
    return url.match(regex);
  };

  useEffect(() => {
    if (coverPhotoAsset && coverPhotoAsset.assetType === "IMAGE") {
      api
        .getResponsiveImage(coverPhotoAsset.id, isSm ? "md" : "lg")
        .then(url => {
          setCoverPhotoUrl(url);
        });
    } else if (coverPhotoAsset && coverPhotoAsset.assetType === "WEB") {
      setCoverPhotoUrl(coverPhotoAsset.id);
    } else if (coverPhotoId && coverPhotoId !== "") {
      if (isUrl(coverPhotoId)) {
        setCoverPhotoUrl(coverPhotoId);
      } else {
        api.getResponsiveImage(coverPhotoId, isSm ? "md" : "lg").then(url => {
          setCoverPhotoUrl(url);
        });
      }
    } else {
      setCoverPhotoUrl(null);
    }
  }, [coverPhotoAsset, coverPhotoId]);

  // Calculate the height percentage based on the coverRatio
  const getCoverRatioStyle = () => {
    if (coverRatio) {
      const [width, height] = coverRatio.split("/");
      return {
        width: "100%",
        height: `${100 - (height / width) * 100}%`, // Set height based on width-to-height ratio
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        gap: 0
      };
    } else if (edit) {
      return { width: "100%", height: "100%" };
    } else {
      return { width: "100%", height: "100%" };
    }
  };

  return (
    <div
      id={id ?? "profile-cover-photo"}
      className={`${
        temporaryImage || coverPhotoUrl
          ? "profile-cover-photo"
          : "profile-cover-photo-nobg"
      } ${className ? className : ""} ${edit ? "edit" : ""}`}
      style={getCoverRatioStyle()} // Set the cover ratio dimensions
    >
      {/* Blurred mirrored background */}
      {coverRatio && (temporaryImage || coverPhotoUrl) && (
        <div
          className="blurred-background"
          style={{
            backgroundImage: `url(${
              temporaryImage ? temporaryImage : coverPhotoUrl
            })`,
            filter: "blur(20px)",
            position: "absolute",
            top: 0,
            left: 0,
            right: "50%",
            bottom: 0,
            zIndex: 1,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "repeat-x" // Ensures background repeats horizontally
          }}
        ></div>
      )}

      {/* Content that fills the height and is centered horizontally */}
      <div
        className="cover-photo-content"
        ref={coverPhotoRef}
        style={{ zIndex: 2 }}
      >
        {(temporaryImage || coverPhotoUrl) && (
          <img
            src={temporaryImage ? temporaryImage : coverPhotoUrl}
            style={
              isSm
                ? {
                    width: "100%",
                    height: "auto",
                    display: "block",
                    objectFit: "cover"
                  }
                : {
                    height: maxHeight ?? "100%",
                    // width: "100%", // Automatically adjust width to maintain aspect ratio
                    objectFit: "cover",
                    display: "block",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    right: 0,
                    bottom: 0
                  }
            }
          />
        )}

        {children && (
          <div
            className={
              edit
                ? "profile-cover-photo-edit-content"
                : "profile-cover-photo-content"
            }
          >
            {children}
          </div>
        )}
      </div>

      {/* Blurred mirrored background */}
      {coverRatio && (temporaryImage || coverPhotoUrl) && (
        <div
          className="blurred-background"
          style={{
            backgroundImage: `url(${
              temporaryImage ? temporaryImage : coverPhotoUrl
            })`,
            filter: "blur(20px)",
            position: "absolute",
            top: 0,
            left: "50%",
            right: 0,
            bottom: 0,
            zIndex: 1,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "repeat-x" // Ensures background repeats horizontally
          }}
        ></div>
      )}
    </div>
  );
};

export default ProfileCoverPhoto;
